<script setup>
import OnDemandEvent from './events/OnDemandEvent.vue';
import InPersonEvent from './events/InPersonEvent.vue';
import VirtualEvent from './events/VirtualEvent.vue';
import EventPage from './EventPage.vue';
import InPersonVirtualEvent from './events/InPersonVirtualEvent.vue';

defineProps({
  event: Object,
  solutions: Array,
  fleetSize: Array,
  isLoading: Boolean,
});

const getEventComponent = (typeEvent) => {
  if (typeEvent === 'ON-DEMAND') return OnDemandEvent;
  if (typeEvent === 'IN-PERSON') return InPersonEvent;
  if (typeEvent === 'VIRTUAL') return VirtualEvent;
  if (typeEvent === 'IN-PERSON/VIRTUAL') return InPersonVirtualEvent;
  return EventPage;
};
</script>
<template>
  <component :is="getEventComponent(event?.typeEvent?.name)"
    :event="event"
    :solutions="solutions"
    :fleetSize="fleetSize"
    :isLoading="isLoading" />
</template>
